import * as React from 'react';
import { Dispatch } from 'redux';
import { useState } from 'react';
import { connect } from 'react-redux';
import { userAction } from '../../actions/userAction';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";

interface IUsersProps {
	dispatch: Dispatch<any>;
	userData: any;
	callback: any;
	userId: string;
}

const UserDetail: React.SFC<IUsersProps> = ({ dispatch, userData, callback, userId }) => {
	
	let dateFormat = "MM/DD/YYYY";

	const userInput = {
		userId: -1,
		userName: "",
		firstName: "",
		lastName: "",
		nickName: '',
		registeredAtUtc: '',
		birthDate: '',
		phoneNumber: '',
		textsAllowed: false,
		emailsAllowed: false,
		email: ''
	}

	const [frmInput, setFrmInput] = useState(userInput);
	const [isErrorOnPage, setIsErrorOnPage] = useState(false); 

	if (userData) {
		if (userData.isError && !isErrorOnPage) {
			setIsErrorOnPage(true);
		}

		if (userData.isDetailComplete) {
			if (userData.item) {
				setFrmInput(userData.item);
				setIsErrorOnPage(false);
			}			
			userData.isDetailComplete=false
		}
	}	

	return (
		<>
			{isErrorOnPage && (<h5 className="text-center">No data found</h5>)}
			{!isErrorOnPage && (
					<table className="table" data-testid="userDetailViewTable">
					<tbody>
						<tr>
						<td className="td50" data-testid="lblFirstName">First Name</td>
							<td data-testid="firstName">
								{frmInput.firstName}
							</td>
						</tr>
						<tr>
							<td data-testid="lblLastName">Last Name</td>
							<td data-testid="lastName">{frmInput.lastName}</td>
						</tr>
						<tr>
							<td data-testid="lblNickName">Nick Name</td>
							<td data-testid="nickNameDetail">{frmInput.nickName}</td>
						</tr>
						<tr>
							<td data-testid="lblEmail">Email</td>
							<td data-testid="email">{frmInput.email}</td>
						</tr>
						<tr>
							<td data-testid="lblRegisteredDate">Registered Date</td>
							<td data-testid="registeredAtDetail">{moment(frmInput.registeredAtUtc).format(dateFormat)}</td>
						</tr>
						<tr>
							<td data-testid="lblBirthDate">Birth Date</td>
							<td data-testid="birthDate">{(moment(frmInput.birthDate).year() > 1900)? moment(frmInput.birthDate).format(dateFormat):""}</td>
						</tr>
						<tr>
							<td data-testid="lblPhoneNumber">Phone Number</td>
							<td data-testid="phoneNumber">{frmInput.phoneNumber}</td>
						</tr>
						<tr>
							<td data-testid="lblEmailAllowed">Emails Allowed</td>
							<td data-testid="emailAllowed">{frmInput.emailsAllowed ? 'Yes' : 'No'}</td>
						</tr>
						<tr>
							<td data-testid="lblTextsAllowed">Texts Allowed</td>
							<td data-testid="textAllowed">{frmInput.textsAllowed ? 'Yes' : 'No'}</td>
						</tr>
					</tbody>
				</table>
			)}
		</>
	)
}

const mapStateToProps = (state: any) => {
	const { userData } = state;
	return {
		userData
	};
};

export default connect(mapStateToProps)(UserDetail);
